import { ProductCodes } from '../../constants'
import { getTotalSubscriptionPlusMembers } from '../../utils/Helper'

const BillingCycle = ({
  activeCycle,
  changeActiveCycle,
  plan,
  activeProduct,
  billingMemberCount,
}) => {
  return (
    activeProduct !== ProductCodes.Free && (
      <div className="tikbox-column tikbox-billing-cycle">
        <>
          <p className="tikbox-title">Billing Cycle After Free Trial</p>
          <div className="tikbox-plan-option">
            <label className={`${activeCycle === 1 ? 'active' : ''}`}>
              <input
                checked={activeCycle === 1}
                type="radio"
                name="planCycle"
                onChange={() => changeActiveCycle(1)}
              />{' '}
              Annual
              <span className="radio-title"> (Save 44%)</span>
            </label>
            <label className={`${activeCycle === 2 ? 'active' : ''}`}>
              <input
                checked={activeCycle === 2}
                type="radio"
                name="planCycle"
                onChange={() => changeActiveCycle(2)}
              />{' '}
              Monthly
              <span className="radio-title"> </span>
            </label>
          </div>
          {activeCycle === 1 ? (
            <p className="discount-info">
              Pay{' '}
              <strong>
                {plan?.priceAnnually &&
                  getTotalSubscriptionPlusMembers(
                    plan?.priceAnnually,
                    billingMemberCount,
                  )}
              </strong>{' '}
              after the trial, receive your full 44% discount, and 12 months
              uninterrupted use of <strong>{plan?.name} plan</strong>
            </p>
          ) : activeCycle === 2 ? (
            <p className="discount-info">
              After the trial, split your payments into{' '}
              <strong>
                {plan?.priceMonthly &&
                  getTotalSubscriptionPlusMembers(
                    plan?.priceMonthly,
                    billingMemberCount,
                  )}
              </strong>
              /month instalments and spread the cost over a year. Receive 12
              months uninterrupted use of <strong>{plan?.name} plan</strong>
            </p>
          ) : (
            ''
          )}
        </>
      </div>
    )
  )
}

export default BillingCycle
